<script setup>
  import { useSpotStore } from '@/stores/SpotStore';
  import { useDetailPanelStore } from '@/stores/DetailPanelStore';
  import ControlButton from '@/components/controls/ControlButton.vue';
  import Icon from '@/components/icons/Icon.vue';

  import useSettingsGlobals from '@/composables/useSettingsGlobals';
  import useMapConfigurationGlobals from '@/composables/useMapConfigurationGlobals';

  const { $WEB_VIEW } = useSettingsGlobals();  
  const { $DETAIL_PANEL } = useMapConfigurationGlobals();  

  const spotStore = useSpotStore();
  const detailPanelStore = useDetailPanelStore();

  // TODO: Composable
  function emitEvent(event) {
    window.$EventBus.dispatchEvent(event);
  }  

  function controlsClickHandler(e) {
    const clickedButton = e.target.closest('[data-action]');

    if (!clickedButton) return;

    const action = clickedButton.dataset.action;

    switch(action) {
      case 'detail-panel':
        detailPanelStore.toggle();
        break;
      case 'storm-panel':
        emitEvent('storm-panel-open');
        break;
    }
  }
</script>

<template>
  <div @click.prevent="controlsClickHandler" class="map__controls jwx-map__controls--secondary">
    <Transition name="slide-in-left">
      <div v-if="!$WEB_VIEW && $DETAIL_PANEL && spotStore.spot !== null" class="jwx-wrapper-block jwx-wrapper-block--transparent-border">
        <ul class="jwx-wrapper-block__content jwx-wrapper-block__items">
          <li class="jwx-wrapper-block__item" >
            <ControlButton
              data-action="detail-panel"
            >
              <Icon name="graph" class="jwx-button-control__icon" />  
            </ControlButton>
          </li>
        </ul>
      </div>
    </Transition>
  </div>
</template>